module.exports = __webpack_public_path__ + "img/yellow.d378e653.png";